import { useEffect, useState, useRef } from "react";

import "./ThoughtBubble.css";

const webDevQuotes = [
	"HTML is the skeleton, CSS is the skin, and JavaScript is the soul of the web.",
	"Without CSS, the web would look like it's still stuck in the '90s.",
	"JavaScript 🚀 : the language that lets you turn a button into a spaceship if you really want.",
	"A div without a className is just another lost soul.",
	"CSS Grid is like playing chess, but with pixels.",
	"Flexbox: because centering things shouldn't feel like dark magic.",
	"JavaScript is single-threaded... but it somehow manages to stress you out in multiple directions.",
	"Responsive design is not optional anymore; it’s survival.",
	"An unstyled HTML page is just an awkward Google Doc.",
	"CSS specificity wars are the Game of Thrones of web dev.",
	"Your website is your first impression — don’t make it look like a Word document.",
	"Every great web app begins with ‘console.log(Hello World)’ and too much coffee.",
	"HTML5 gave us <video> and <audio>... goodbye Flash, we won’t miss you.",
	"Web development: where one missing semicolon can ruin your entire evening.",
	"A slow website is like a fast car with a flat tire — pointless.",
	"UI is the joke, UX is whether people laugh.",
	"Good UX is invisible; bad UX screams at you in Comic Sans.",
	"Never underestimate the power of a well-placed hover effect.",
	"CSS is proof that beauty can be both powerful and painful.",
	"Accessibility isn’t optional — it’s respect in code form.",
	"JavaScript frameworks are like fashion trends — exciting, but they change every year.",
	"The box model: where every beginner cries at least once.",
	"Inline CSS: the duct tape of styling — quick fix, ugly result.",
	"A 404 page can either ruin someone’s day or make them laugh.",
	"A button without feedback is like a doorbell that doesn’t ring.",
	"Web performance isn’t just about speed, it’s about respect for the user’s time.",
	"Dark mode is not just a feature, it’s a lifestyle.",
	"The DOM is like a messy kitchen: you can cook in it, but you’ll hate cleaning up.",
	"UX design: making sure users don’t rage quit your website.",
	"CSS variables: because copy-pasting hex codes 50 times is not a personality trait.",
	"Never trust a website that takes longer to load than to explain quantum physics.",
	"Progressive enhancement: because not everyone has the latest iPhone.",
	"A good UI is like good manners: you barely notice them, but you feel their absence immediately.",
	"Deploying code on Friday evening is the fastest way to test your stress levels.",
	"JS promises: like real-life promises, they sometimes get broken.",
	"LocalStorage: because sometimes you just need a little memory without a database.",
	"The internet runs on caffeine, cats, and console.log().",
	"CSS transitions: making buttons 20% more satisfying since 2009.",
	"Inline styles are like fast food: quick, easy, and regrettable later.",
	"An unoptimized image is the heaviest villain on your website.",
	"Forms: the place where UX goes to die or shine.",
	"Minification: turning your code into a secret language only machines understand.",
	"Your code editor theme says more about you than your resume.",
	"Web design trends come and go, but bad navigation is forever annoying.",
	"SEO without content is like CSS without HTML — pretty useless.",
	"Lighthouse isn’t judging you… okay, it kind of is.",
	"Every developer has fought the battle of CSS vs Browser Compatibility.",
	"A spinner loader is just a polite way of saying ‘we’re slow.’",
	"Cookies: not as tasty as the name suggests, but still addictive.",
	"Good micro-interactions can make your users smile; bad ones can make them uninstall.",
	"JavaScript frameworks: so many to learn, so little time.",
	"Don’t make users think. That’s what books are for, not buttons.",
	"Whitespace in design isn’t empty — it’s breathing space.",
	"Alt text is not just for SEO, it’s for humans too.",
	"CSS animations: for when you want your website to dance a little.",
	"A developer without Git is like a writer without undo.",
	"The hardest thing in web development? Naming classNamees.",
	"If your website only works on Chrome, you don’t have a website, you have a Chrome extension.",
	"Design for thumbs, not cursors — most users are on mobile.",
	"The scrollbar is the modern attention span meter.",
	"Building a website without testing on mobile is like building a car without checking the brakes.",
	"Favicon: the tiny icon that makes your site feel 10x more legit.",
	"Frameworks come and go, but HTML will always be home.",
	"CSS cascade is like parenting — sometimes the child inherits things you didn’t mean to pass on.",
	"Forms need validation, because people will type their phone number as ‘1234567890lol.’",
	"Don’t ignore accessibility — the web is for everyone, not just you.",
	"UX is not just about looking good; it’s about not making people rage-quit.",
	"Never hardcode values you’ll regret later. Future you is watching.",
	"One pixel off? Congratulations, you’ll now spend 3 hours fixing it.",
	"Static websites load faster, but dynamic ones make you feel like a wizard.",
	"A sticky header can be your best friend or your worst nightmare.",
	"Hover effects don’t exist on mobile, so don’t make them essential.",
	"Design is how it looks; UX is how it works when you’re frustrated at 2 AM.",
	"Not all animations are good — sometimes they’re just distractions in disguise.",
	"A website without responsiveness is like a book you can only read on one shelf.",
	"Code readability is for humans. The computer already understands it.",
	"If you think CSS is easy, you haven’t tried aligning items vertically yet.",
	"A good website feels fast even when it isn’t.",
	"Use comments in your code. Your future self will thank you.",
	"JavaScript is the duct tape of the internet — messy, but it holds everything together.",
	"Design for accessibility first, beauty second. Beauty without accessibility is useless.",
	"The web was built to share documents, and now we use it to share memes — progress?",
	"If you don’t test your website on a slow network, you don’t care about your users.",
	"CSS bugs don’t show errors; they show embarrassment.",
	"Your homepage is your handshake — make it firm, not weak.",
	"Frameworks may change, but good UX principles never do.",
	"The console is a developer’s diary — full of secrets and regrets.",
	"Every developer has asked: ‘Why isn’t my CSS applying?’ at least once.",
	"Good error messages are part of UX. Bad ones are just insults.",
	"Never forget: users don’t care about your code; they care about what it does.",
];

function displayQuotes(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}
export function ThoughtBubble() {
	const [stage, setStage] = useState("dashes");
	const [typedText, setTypedText] = useState("");
	const [done, setDone] = useState(false);

	const typingTimerRef = useRef(null);
	const stageTimerRef = useRef(null);
	const textRef = useRef(null);

	const [fullText] = useState(() => displayQuotes(webDevQuotes));
	const typingSpeed = 90;

	// Stage transitions: dashes -> blur -> text
	useEffect(() => {
		stageTimerRef.current = setTimeout(() => setStage("blur"), 1300);
		return () => clearTimeout(stageTimerRef.current);
	}, []);

	useEffect(() => {
		if (stage === "blur") {
			stageTimerRef.current = setTimeout(() => setStage("text"), 1500);
			return () => clearTimeout(stageTimerRef.current);
		}
	}, [stage]);

	// Typing effect
	useEffect(() => {
		if (stage !== "text") return;

		setTypedText("");
		setDone(false);
		clearTimeout(typingTimerRef.current);

		let index = 0;

		function tick() {
			index += 1;
			setTypedText(fullText.slice(0, index));

			if (index < fullText.length) {
				typingTimerRef.current = setTimeout(tick, typingSpeed);
			} else {
				setDone(true);
			}
		}

		typingTimerRef.current = setTimeout(tick, typingSpeed);

		return () => {
			clearTimeout(typingTimerRef.current);
		};
	}, [stage, fullText, typingSpeed]);

	// Auto-scroll text upward when it overflows
	useEffect(() => {
		if (stage === "text" && textRef.current) {
			const textElement = textRef.current;
			const container = textElement.parentElement;

			if (textElement.scrollHeight > container.clientHeight) {
				const overflow = textElement.scrollHeight - container.clientHeight;
				textElement.style.transform = `translateY(-${overflow}px)`;
			}
		}
	}, [typedText, stage]);

	const dashesContent = `------ ------ ------
______ ______ ______
------ ------ ------
______ ______ ______`;

	return (
		<div className="box">
			{stage === "dashes" && <pre className="dashes">{dashesContent}</pre>}

			{stage === "blur" && <pre className="dashes blur">{dashesContent}</pre>}

			{stage === "text" && (
				<div className="text-line">
					<div className="text-content-wrapper" ref={textRef}>
						<p className="text">{typedText}</p>
						<span
							className="cursor"
							style={{ visibility: done ? "hidden" : "visible" }}
						/>
					</div>
				</div>
			)}
		</div>
	);
}

// export function ThoughtBubble() {
// 	const [stage, setStage] = useState("dashes"); // "dashes" -> "blur" -> "text"
// 	const [typedText, setTypedText] = useState("");
// 	const [done, setDone] = useState(false);

// 	const typingTimerRef = useRef(null);
// 	const stageTimerRef = useRef(null);
// 	const textRef = useRef(null); // ADD THIS

// 	const [fullText] = useState(
// 		() => displayQuotes(webDevQuotes) + "baad baad baad baad baad"
// 	);
// 	const typingSpeed = 90; // ms per character

// 	// start blur after 5s
// 	useEffect(() => {
// 		stageTimerRef.current = setTimeout(() => setStage("blur"), 5000);
// 		return () => clearTimeout(stageTimerRef.current);
// 	}, []);

// 	// after blur, move to text stage
// 	useEffect(() => {
// 		if (stage === "blur") {
// 			stageTimerRef.current = setTimeout(() => setStage("text"), 1500);
// 			return () => clearTimeout(stageTimerRef.current);
// 		}
// 	}, [stage]);

// 	// typing effect using a recursive setTimeout chain (robust)
// 	useEffect(() => {
// 		if (stage !== "text") return;

// 		// reset states in case of re-entry
// 		setTypedText("");
// 		setDone(false);
// 		clearTimeout(typingTimerRef.current);

// 		let index = 0;

// 		function tick() {
// 			index += 1; // increment first so first tick shows fullText.slice(0,1) => first char
// 			setTypedText(fullText.slice(0, index));

// 			if (index < fullText.length) {
// 				typingTimerRef.current = setTimeout(tick, typingSpeed);
// 			} else {
// 				setDone(true);
// 			}
// 		}

// 		// start typing after a very short delay so blur animation can finish visually
// 		typingTimerRef.current = setTimeout(tick, typingSpeed);

// 		useEffect(() => {
// 			if (stage === "text" && textRef.current) {
// 				const textElement = textRef.current;
// 				const container = textElement.parentElement;

// 				// Check if content overflows
// 				if (textElement.scrollHeight > container.clientHeight) {
// 					// Calculate how much to scroll up
// 					const overflow = textElement.scrollHeight - container.clientHeight;
// 					textElement.style.transform = `translateY(-${overflow}px)`;
// 				}
// 			}
// 		}, [typedText, stage]);

// 		return () => {
// 			clearTimeout(typingTimerRef.current);
// 		};
// 	}, [stage, fullText]);

// 	useEffect(() => {
// 		if (stage === "text" && textRef.current) {
// 			const textElement = textRef.current;
// 			const container = textElement.parentElement;

// 			// Check if content overflows
// 			if (textElement.scrollHeight > container.clientHeight) {
// 				// Calculate how much to scroll up
// 				const overflow = textElement.scrollHeight - container.clientHeight;
// 				textElement.style.transform = `translateY(-${overflow}px)`;
// 			}
// 		}
// 	}, [typedText, stage]);

// 	return (
// 		<div className="box">
// 			{stage === "dashes" && (
// 				<pre className="dashes">
// 					{`------ ------ ------
// ______ ______ ______
// ------ ------ ------
// ______ ______ ______`}
// 				</pre>
// 			)}

// 			{stage === "blur" && (
// 				<pre className="dashes blur">
// 					{`------ ------ ------
// ______ ______ ______
// ------ ------ ------
// ______ ______ ______`}
// 				</pre>
// 			)}

// 			{stage === "text" && (
// 				<div className={"text-line "}>
// 					{" "}
// 					{/* ADD className conditionally */}
// 					<p className="text" ref={textRef}>
// 						{" "}
// 						{typedText}
// 					</p>
// 					{/* ADD ref */}
// 					{/* blinking cursor; hide when done */}
// 					<span
// 						className="cursor"
// 						style={{ visibility: done ? "hidden" : "visible" }}
// 					/>
// 				</div>
// 			)}
// 		</div>
// 	);
// }
